import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Project } from 'Models/project'
import React from 'react'
import ProjectOverviewDetails from './ProjectOverviewDetails'
import ProjectOverviewImageCard from './ProjectOverviewImageCard'

interface ProjectOverviewHeaderProps {
    projectData: Partial<Project> | undefined
    triggerProjectReload: VoidFunction
    variant?: 'readOnly' | 'full'
}
export const ProjectOverviewHeader: React.FC<ProjectOverviewHeaderProps> = ({
    projectData,
    triggerProjectReload,
    variant,
}) => {
    return (
        <GridContainer
            data-testid="dvProjectOverviewHeader"
            direction="column"
            justifyContent="space-evenly"
        >
            <GridItem>
                <ProjectOverviewImageCard
                    variant={variant}
                    projectData={projectData}
                />
            </GridItem>
            <GridItem>
                <ProjectOverviewDetails
                    projectData={projectData}
                    triggerProjectReload={triggerProjectReload}
                    variant={variant}
                />
            </GridItem>
        </GridContainer>
    )
}
export default ProjectOverviewHeader
